import React, { useEffect, useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import Section from '../Atoms/Section';
import BigH1 from '../Atoms/BigH1';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import placeholderIMG from '../../Components/img/placeholderIMG.png';
import BlueButton from '../Atoms/BlueButton';
import styled from 'styled-components';
import BigH2 from '../Atoms/BigH2';
import BigH3 from '../Atoms/BigH3';
import News from '../Components/News';
import Worldmaphome from '../Components/WorldmapHome';
import InstagramWidget from '../Components/InstagramWidget';
import AnimatedSection from '../Components/AnimatedSection';
import { supabase } from '../../lib/supabaseClient';
import * as api from '../../api';

const StyledSection = styled(Section)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    margin: 0;
    padding: 0;
    /* height: auto; */
`;

const Content = styled.div`
    max-width: 60%;
    margin-left: 40px;

    @media screen  and (max-width: 768px) {
        max-width: 100%;
        margin:auto;
        text-align: center;
    padding: 30px;   }
`;

const ButtonWrapper = styled.div`
    margin-top: 30px;
`;

const Title = styled.div`
    width: 100%;
    border-bottom: 1px solid black;
    padding: 30px 0;
    text-align: left;
    padding-left:40px;
    text-transform:'uppercase';
`;

const ServiceSection = styled(Section)`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const BigH1Home = styled(BigH1)`
   @media screen  and (max-width: 1600px) {
    font-size:80px;
    line-height:70px;
   }

   @media screen  and (max-width: 1200px) {
    font-size:60px;
    line-height:50px;
   }
`;


const Subsection = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center; /* Ensures both blocks are the same height */
    height: auto;
    gap: 20px;
    @media screen  and (max-width: 1200px) {
 flex-direction:column;
   }

`;

const BulletPoints = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    padding-left:40px;
    margin: 20px 0;

    ul {
        list-style-type: disc;
        padding-left: 20px;
        padding-top:10px;

        li {
            margin-bottom: 10px;
        }
    }
`;

const VideoWrapper = styled.div`
    flex: 1 1 80%;
    position: relative;
    display: flex;
    align-items: center;

    @media screen  and (max-width: 1200px) {
 width:100%;
   }

    /* Ensures the video maintains its 16:9 aspect ratio */
    &::before {
        content: "";
        display: block;
        padding-top: 56.25%; /* 16:9 Aspect Ratio */
    }

    iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: none;
       
    }
`;

const Visuel = styled.img`
    position: relative;
    max-height: 100%;
    max-width: 40%;
    object-fit: contain;
`;

const CardGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); /* Responsive grid */
    gap: 20px;
    padding: 20px;
`;

const TopPostCont = styled.div`
 width:30%;

 @media screen  and (max-width: 768px) {
 width:100%;
   }

`;

const ActualitesSection = styled.div`
    width: 100%;
    padding: 40px;
`;

const EventBannerSection = styled(Link)`
    display: block;
    background: linear-gradient(135deg, #0010ff, #0008cc);
    padding: 32px 0;
    color: white;
    text-decoration: none;
    transition: all 0.3s;

    &:hover, &:visited, &:active, &:focus {
        color: white;
        text-decoration: none;
    }

    &:hover {
        background: linear-gradient(135deg, #0008cc, #000699);
    }

    @media (max-width: 768px) {
        padding: 24px 0;
    }
`;

const EventBannerInner = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;

    @media (max-width: 768px) {
        flex-direction: column;
        text-align: center;
        padding: 0 20px;
    }
`;

const EventBannerText = styled.div`
    flex: 1;
`;

const EventBannerTitle = styled.h2`
    font-size: 22px;
    font-weight: 800;
    margin: 0 0 4px 0;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: white;

    @media (max-width: 768px) {
        font-size: 18px;
    }
`;

const EventBannerDate = styled.div`
    font-size: 15px;
    color: rgba(255, 255, 255, 0.85);
    margin-bottom: 8px;
    font-weight: 600;
`;

const EventBannerDesc = styled.p`
    font-size: 14px;
    color: rgba(255, 255, 255, 0.75);
    margin: 0;
    max-width: 500px;
    line-height: 1.4;

    @media (max-width: 768px) {
        margin: 0 auto;
    }
`;

const EventBannerCTA = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 12px 28px;
    background: white;
    color: #0010ff;
    font-size: 14px;
    font-weight: 700;
    border-radius: 100px;
    white-space: nowrap;
    transition: all 0.25s;
    flex-shrink: 0;

    ${EventBannerSection}:hover & {
        transform: translateY(-2px);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
    }
`;

const VoteBannerSection = styled.div`
    background: linear-gradient(135deg, rgb(24, 51, 189), rgb(18, 38, 140));
    padding: 36px 0 32px;
    color: white;

    @media (max-width: 768px) {
        padding: 28px 0 24px;
    }
`;

const VoteBannerInner = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 32px;
    text-align: center;

    @media (max-width: 768px) {
        padding: 0 20px;
    }
`;

const VoteBannerTitle = styled.h2`
    font-size: 26px;
    font-weight: 800;
    margin: 0 0 6px 0;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: white;

    @media (max-width: 768px) {
        font-size: 20px;
    }
`;

const VoteBannerSubtitle = styled.p`
    font-size: 15px;
    color: rgba(255, 255, 255, 0.85);
    margin: 0 0 24px 0;
    max-width: 560px;
    margin-left: auto;
    margin-right: auto;
    line-height: 1.5;

    @media (max-width: 768px) {
        font-size: 14px;
        margin-bottom: 20px;
    }
`;

const VoteBannerCTA = styled(Link)`
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 12px 32px;
    background: white;
    color: rgb(24, 51, 189);
    font-size: 15px;
    font-weight: 700;
    text-decoration: none;
    border-radius: 100px;
    transition: all 0.25s;

    &:hover, &:visited, &:active, &:focus {
        color: rgb(24, 51, 189);
        text-decoration: none;
    }

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
    }
`;

const VoteBannerTrendingLabel = styled.div`
    font-size: 13px;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.7);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 6px;
`;

const VoteBannerCarouselScroll = styled.div`
    overflow-x: auto;
    max-width: 100%;
    padding-bottom: 8px;

    &::-webkit-scrollbar { height: 0; }
`;

const VoteBannerCarousel = styled.div`
    display: flex;
    gap: 14px;
    width: fit-content;
    margin: 0 auto;
    padding: 4px 4px 8px;
`;

const VoteBannerProjectCard = styled(Link)`
    flex-shrink: 0;
    width: 140px;
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    overflow: hidden;
    text-decoration: none;
    color: white;
    transition: all 0.2s;

    &:hover, &:visited, &:active, &:focus {
        color: white;
        text-decoration: none;
    }

    &:hover {
        background: rgba(255, 255, 255, 0.2);
        transform: translateY(-3px);
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
    }
`;

const VoteBannerProjectImg = styled.div`
    width: 100%;
    padding-top: 75%;
    background-size: cover;
    background-position: center;
    background-color: rgba(255, 255, 255, 0.08);
`;

const VoteBannerProjectInfo = styled.div`
    padding: 10px;
`;

const VoteBannerProjectName = styled.div`
    font-size: 11px;
    font-weight: 700;
    line-height: 1.3;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-transform: uppercase;
`;

const VoteBannerProjectDesigner = styled.div`
    font-size: 10px;
    color: rgba(255, 255, 255, 0.65);
    margin-top: 3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const EVENT_ID = '67590da5499bcc995c210b40';

const Homepage = (props) => {
    const { i18n } = useTranslation('common');
    const isFr = i18n.language === 'fr';

    // Fetch top voted projects for the banner carousel
    const [topProjects, setTopProjects] = useState([]);

    useEffect(() => {
        (async () => {
            try {
                const allVotes = [];
                const PAGE_SIZE = 1000;
                let from = 0;
                while (true) {
                    const { data } = await supabase
                        .from('fd100_votes')
                        .select('project_id')
                        .range(from, from + PAGE_SIZE - 1);
                    if (!data || data.length === 0) break;
                    allVotes.push(...data);
                    if (data.length < PAGE_SIZE) break;
                    from += PAGE_SIZE;
                }
                if (!allVotes.length) return;
                const counts = {};
                allVotes.forEach(v => { counts[v.project_id] = (counts[v.project_id] || 0) + 1; });
                const top10Pids = Object.entries(counts)
                    .sort(([, a], [, b]) => b - a)
                    .slice(0, 10)
                    .map(([pid]) => pid);
                if (!top10Pids.length) return;

                const [namesRes, basicRes] = await Promise.all([
                    supabase
                        .from('fd100_project_names')
                        .select('project_id, name_definitive_fr, name_definitive_en, designer_definitive')
                        .eq('event_id', EVENT_ID)
                        .in('project_id', top10Pids),
                    api.getProjectsBasicData({ projectIds: top10Pids }),
                ]);

                const merged = {};
                if (namesRes.data) {
                    namesRes.data.forEach(item => {
                        merged[item.project_id] = {
                            name_fr: item.name_definitive_fr,
                            name_en: item.name_definitive_en,
                            designer: item.designer_definitive,
                        };
                    });
                }
                if (basicRes.data) {
                    Object.entries(basicRes.data).forEach(([pid, info]) => {
                        if (!merged[pid]) merged[pid] = {};
                        merged[pid].imagePath = info.imagePath;
                    });
                }

                // Shuffle for display
                const items = [...top10Pids];
                for (let i = items.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [items[i], items[j]] = [items[j], items[i]];
                }
                setTopProjects(items.map(pid => ({ pid, ...merged[pid] })));
            } catch (e) {
                console.warn('Homepage: failed to fetch top projects', e);
            }
        })();
    }, []);

    return (
        <div>
            {/* First Section */}
            <AnimatedSection direction="left">

            <StyledSection className="homesection">

                <Content>

                    <BigH1Home>CONNECTED BY <br /> Le FRENCH DESIGN</BigH1Home>
                    <ButtonWrapper>
                    {!props.fullUser &&  <a href="/login"> <BlueButton>
                            <img src="/img/fleche_blanche.png" alt="" />
                            {i18n.language === "fr" ? "Inscription" : "Sign Up"}
                        </BlueButton></a> }
                    </ButtonWrapper>
                </Content>

             <TopPostCont>

                <InstagramWidget/>
                </TopPostCont>
            </StyledSection>
            </AnimatedSection>

            {/* SDO 2026 Event Banner - hidden, event over (29/09/2026)
            <EventBannerSection to="/evenements/sdo2026">
                <EventBannerInner>
                    <img src="/img/sdo2026/bandeau-logo.png" alt="Speed Dating Design Objet" style={{ height: '100%', maxHeight: 120, width: 'auto', borderRadius: 6, flexShrink: 0, alignSelf: 'stretch', objectFit: 'contain' }} />
                    <EventBannerText>
                        <EventBannerTitle>Speed Dating Design Objet</EventBannerTitle>
                        <EventBannerDate>
                            {isFr ? 'Mardi 29 septembre 2026, 14h-18h — Paris' : 'Tuesday September 29, 2026, 2pm-6pm — Paris'}
                        </EventBannerDate>
                        <EventBannerDesc>
                            {isFr
                                ? <>Rencontres entre fabricants et designers produit.<br/>Jusqu'à 8 rendez-vous en 1/2 journée.</>
                                : <>Meetings between manufacturers and product designers.<br/>Up to 8 meetings in half a day.</>}
                        </EventBannerDesc>
                    </EventBannerText>
                    <EventBannerCTA>
                        {isFr ? "Plus d'infos" : 'More info'} &rarr;
                    </EventBannerCTA>
                </EventBannerInner>
            </EventBannerSection>
            */}

            {/* Prix du Public Banner - hidden
            <VoteBannerSection>
                <VoteBannerInner>
                    <VoteBannerTitle>
                        {isFr ? 'Prix du Public' : "People's Choice Award"}
                    </VoteBannerTitle>
                    <VoteBannerSubtitle>
                        {isFr
                            ? 'Votez pour vos projets préférés parmi les 100 lauréats Le FD100. Un vote par projet, votez pour autant de projets que vous le souhaitez !'
                            : 'Vote for your favourite projects among the 100 Le FD100 winners. One vote per project, vote for as many as you like!'}
                    </VoteBannerSubtitle>
                    {topProjects.length > 0 && (
                        <>
                        <VoteBannerTrendingLabel>
                            &#128293; {isFr ? 'Projets tendance en ce moment' : 'Trending projects right now'}
                        </VoteBannerTrendingLabel>
                        <VoteBannerCarouselScroll>
                        <VoteBannerCarousel>
                            {topProjects.map(({ pid, name_fr, name_en, designer, imagePath }) => {
                                const name = isFr ? (name_fr || name_en || '') : (name_en || name_fr || '');
                                const imageUrl = imagePath
                                    ? process.env.REACT_APP_MEDIA_BASE_URL + 'userfiles/' + imagePath
                                    : null;
                                return (
                                    <VoteBannerProjectCard key={pid} to={`/vote/fd100/${pid}`}>
                                        <VoteBannerProjectImg style={{ backgroundImage: imageUrl ? `url(${imageUrl})` : 'none' }} />
                                        <VoteBannerProjectInfo>
                                            <VoteBannerProjectName>{name}</VoteBannerProjectName>
                                            {designer && <VoteBannerProjectDesigner>{designer}</VoteBannerProjectDesigner>}
                                        </VoteBannerProjectInfo>
                                    </VoteBannerProjectCard>
                                );
                            })}
                        </VoteBannerCarousel>
                        </VoteBannerCarouselScroll>
                        </>
                    )}
                    <div style={{ marginTop: topProjects.length > 0 ? '20px' : '0' }}>
                        <VoteBannerCTA to="/vote/fd100">
                            {isFr ? 'Voter maintenant' : 'Vote now'} &rarr;
                        </VoteBannerCTA>
                    </div>
                </VoteBannerInner>
            </VoteBannerSection>
            */}

            {/* Second Section */}
            <ServiceSection>
                {/* Title */}
                <AnimatedSection direction="left" delay={200}>

                <Title>
                    <BigH2 style={{textTransform:'uppercase'}}>Nos Services</BigH2>
                </Title>
                </AnimatedSection>


                {/* Subsection */}
                <Subsection>
                    {/* Bullet Points */}
                    <AnimatedSection direction="right" delay={400}>

                    <BulletPoints>
                    <BigH3>
    {i18n.language === "fr"
        ? "Intégrer notre communauté pour accéder aux services suivants :"
        : "Join our community to access the following services:"}
</BigH3>                        <ul>
                        <li>
                            {i18n.language === "fr"
                                ? "Accès à notre annuaire avec plus de 700 contacts qualifiés et 1500 projets design objet & espace."
                                : "Access to our directory with over 700 qualified contacts and 1500 design projects (object & space)."}
                        </li>
                        <li>
                            {i18n.language === "fr"
                                ? "Publication de votre profil dans l’annuaire pour accroître votre visibilité."
                                : "Publication of your profile in the directory to increase your visibility."}
                        </li>
                        <li>
                            {i18n.language === "fr"
                                ? "Valorisation de vos projets auprès de la communauté et de nos partenaires."
                                : "Highlighting your projects to the community and our partners."}
                        </li>
                        <li>
                            {i18n.language === "fr"
                                ? "Accès à des ressources documentaires sectorielles spécialisées :"
                                : "Access to specialized sectoral documentary resources."}
                        </li>
                        <li style={{marginLeft:"20px", listStyleType: "none"}} >
                            {i18n.language === "fr"
                                ? "- Guide juridique pour accompagner vos démarches professionnelles."
                                : "- Legal guide to support your professional endeavors."}
                        </li>
                        <li  style={{marginLeft:"20px", listStyleType: "none"}}>
                            {i18n.language === "fr"
                                ? "- Cahiers de styles pour nourrir vos créations."
                                : "- Style books to inspire your creations."}
                        </li>
                        <li>
                            {i18n.language === "fr"
                                ? "Accès à nos actualités en exclusivité (interview, webinaire de formation, etc.)."
                                : "Exclusive access to our news (interviews, training webinars, etc.)."}
                        </li>
                    </ul>
                    </BulletPoints>
                    </AnimatedSection>

                    {/* Video */}
                    <VideoWrapper>
                        <iframe
                            src="https://www.youtube.com/embed/nMyyumkGeq8?si=c8Lk1O6g_nqwn0-2" // Replace with your video URL
                            title="Service Video"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </VideoWrapper>
                </Subsection>
            </ServiceSection>
            <AnimatedSection direction="right" delay={400}>
            <ServiceSection>
                {/* Title */}
                <Title>
                    <BigH2 style={{textTransform:'uppercase'}}>Actualités</BigH2>
                </Title>        
                <News/>
                {/* Subsection */}
               
            </ServiceSection>
            </AnimatedSection>
            <AnimatedSection direction="up" delay={600}>
            <ServiceSection>
                {/* Title */}
                <Title>
                    <BigH2 style={{textTransform:'uppercase'}}>Worldmap</BigH2>
                </Title>

                {/* Subsection */}
                <Worldmaphome/>
            </ServiceSection>
            </AnimatedSection>
        </div>
    );
};

export default Homepage;
